module.exports = __webpack_public_path__ + "static/img/暂无内容.6b7e13c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无内容.jpg
// module id = RD1y
// module chunks = 1